import React from "react"
import { Box, Container, Grid } from "@mui/material"

import { makeStyles } from "makeStyles"

import Shield from "svg/datenschutz.svg"

const useStyles = makeStyles()(() => ({
	root: {
		"& p": {
			opacity: 0.75,
			margin: 0,
		},
		"& h2": {
			fontSize: "1.1rem",
			marginTop: 50,
		},
	},
}))

const DataPolicy = () => {
	const { classes } = useStyles()

	return (
		<Box py={5} style={{ background: "#042C33", color: "#fff" }} className={classes.root}>
			<Container>
				<h1>Datenschutzerklärung</h1>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<p>
							Wir legen größten Wert auf den Schutz Ihrer Daten und die Wahrung Ihrer
							Privatsphäre. Nachstehend informieren wir Sie deshalb über die Erhebung
							und Verwendung persönlicher Daten bei Nutzung unserer Webseite.
						</p>
						<h2>Anonyme Datenerhebung</h2>
						<p>
							Sie können unsere Webseiten besuchen, ohne Angaben zu Ihrer Person zu
							machen. Wir speichern in diesem Zusammenhang keinerlei persönliche
							Daten. Um unser Angebot zu verbessern, werten wir lediglich statistische
							Daten aus, die keinen Rückschluss auf Ihre Person erlauben.
						</p>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Shield style={{ width: "100%", maxHeight: 350 }} />
					</Grid>
					<Grid item xs={12} sm={6}>
						<h2>Erhebung und Verarbeitung bei Nutzung des Kontaktformulars</h2>
						<p>
							Bei Nutzung des Kontaktformulars erheben wir personenbezogene Daten
							(Einzelangaben über persönliche oder sachliche Verhältnisse einer
							bestimmten oder bestimmbaren natürlichen Person) nur in dem von Ihnen
							zur Verfügung gestellten Umfang. Ihre E-Mail-Adresse nutzen wir nur zur
							Bearbeitung Ihrer Anfrage. Ihre Daten werden anschließend gelöscht,
							sofern Sie der weitergehenden Verarbeitung und Nutzung nicht zugestimmt
							haben.
						</p>
						<h2>Erhebung, Verarbeitung und Nutzung personenbezogener Daten</h2>
						<p>
							Wir erheben personenbezogene Daten (Einzelangaben über persönliche oder
							sachliche Verhältnisse einer bestimmten oder bestimmbaren natürlichen
							Person) nur in dem von Ihnen zur Verfügung gestellten Umfang. Die
							Verarbeitung und Nutzung Ihrer personenbezogenen Daten erfolgt zur
							Erfüllung und Abwicklung Ihrer Bestellung sowie zur Bearbeitung Ihrer
							Anfragen. Nach vollständiger Vertragsabwicklung werden alle
							personenbezogenen Daten zunächst unter Berücksichtigung steuer- und
							handelsrechtlicher Aufbewahrungsfristen gespeichert und dann nach
							Fristablauf gelöscht, sofern Sie der weitergehenden Verarbeitung und
							Nutzung nicht zugestimmt haben.
						</p>
						<h2>Weitergabe personenbezogener Daten</h2>
						<p>
							Eine Weitergabe Ihrer Daten an Dritte ohne Ihre ausdrückliche
							Einwilligung erfolgt nicht. Ausgenommen hiervon sind lediglich unsere
							Dienstleistungspartner, die wir zur Abwicklung des Vertragsverhältnisses
							benötigen. In diesen Fällen beachten wir strikt die Vorgaben des
							Bundesdatenschutzgesetzes. Der Umfang der Datenübermittlung beschränkt
							sich auf ein Mindestmaß.
						</p>
					</Grid>
					<Grid item xs={12} sm={6}>
						<h2>Datenerhebung bei Verfassung eines Kommentars</h2>
						<p>
							Wir erheben personenbezogene Daten im Rahmen Ihrer Kommentierung zu
							einem Artikel oder Beitrag nur in dem Umfang, wie sie von Ihnen
							mitgeteilt werden.
						</p>
						<h2>Verwendung der E-Mail-Adresse für die Zusendung von Newslettern</h2>
						<p>
							Wir nutzen Ihre E-Mail-Adresse unabhängig von der Vertragsabwicklung
							ausschließlich für eigene Werbezwecke zum Newsletterversand, sofern Sie
							dem ausdrücklich zugestimmt haben. Ihre diesbezüglich abzugebende
							Einwilligungserklärung lautet wie folgt:
						</p>
						<h2>“Newsletter abonnieren ”</h2>
						<p>
							Sie können den Newsletter jederzeit unter Nutzung des entsprechenden
							Link im Newsletter oder durch Nachricht an uns abbestellen, die
							Kontaktdaten hierzu finden Sie in unserem Impressum. Ihre E-Mail-Adresse
							wird danach aus dem Verteiler gelöscht.
						</p>
					</Grid>
				</Grid>
			</Container>
		</Box>
	)
}

export default DataPolicy
